import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '~/../../tailwind.config.js';
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const fullConfig = resolveConfig(tailwindConfig) as any;

@Injectable({
  providedIn: 'root',
})
export class MatchMediaService {
  private readonly isMobileDevice$ = new BehaviorSubject(
    this.matchMedia(fullConfig.theme?.screens?.md)
  );
  private readonly isTabletDevice$ = new BehaviorSubject(
    this.matchMedia(fullConfig.theme.screens.lg)
  );

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: string
  ) {}

  private matchMedia(breakpoint): boolean {
    if (isPlatformServer(this.platformId)) {
      return false;
    }

    return this.document.defaultView.matchMedia(
      `(max-width: ${breakpoint - 1}px)`
    ).matches;
  }

  public initialize(): void {
    this.isMobileDevice$.next(this.matchMedia(fullConfig.theme?.screens?.md));
    this.isTabletDevice$.next(this.matchMedia(fullConfig.theme?.screens?.lg));
  }

  public isMobileDevice(): Observable<boolean> {
    return this.isMobileDevice$.pipe(distinctUntilChanged());
  }

  public isTabletDevice(): Observable<boolean> {
    return this.isTabletDevice$.pipe(distinctUntilChanged());
  }

  public resizeHandler(): Observable<Event> {
    return fromEvent(this.document.defaultView, 'resize').pipe(
      tap(() => this.initialize())
    );
  }

  public isAppleDevice(): boolean {
    const nav: any = navigator as any;

    const platform = (
      nav.userAgentData?.platform || navigator.userAgent
    ).toLowerCase();

    return /(iphone|ipad|ipod|macintosh|ios|mac)/.test(platform);
  }

  public isAndroidDevice(): boolean {
    const nav: any = navigator as any;

    const platform = (
      nav.userAgentData?.platform || navigator.userAgent
    ).toLowerCase();

    return /android/.test(platform);
  }
}
